import { Spinner, theme } from '@zappyrent/hundop';
import { CtaButton, IUserType } from '@zappyrent/hundop';
import { rem } from 'polished';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem('24px')};
`;

export const StyledSection = styled.section`
  display: flex;
  flex-direction: row;
  gap: ${rem('8px')};

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.m}) {
    flex-direction: column;
  }
`;

export const StyledSectionTitleWrapper = styled.div<IUserType>`
  color: ${({ theme, user }) => theme.colors[user!].main};
  background-color: ${({ theme, user }) => theme.colors[user!].mainPale};
  border-radius: ${rem('8px')};
  padding: ${rem('16px')};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${rem('12px')};
  min-width: ${rem('120px')};

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.m}) {
    justify-content: flex-start;
  }
`;

export const StyledSectionTitle = styled.h3`
  font-size: ${rem('15px')};
  font-weight: 600;
  margin: 0;
  display: none;
  line-height: 0%;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.m}) {
    display: block;
  }
`;

export const StyledActionSectionTitle = styled.h3`
  font-size: ${rem('15px')};
  font-weight: 800;
  margin: 0;
  line-height: 0%;
`;

export const StyledDescriptionList = styled.dl`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(${rem('140px')}, 1fr));
  width: 100%;
  row-gap: ${rem('24px')};
  column-gap: ${rem('48px')};
  background-color: ${({ theme }) => theme.colors.cross.ultralightGray};
  border-radius: ${rem('8px')};
  padding: ${rem('16px')};
  margin: 0;

  & dt {
    padding: 0;
    font-size: ${rem('14px')};
    font-weight: 500;
    color: ${({ theme }) => theme.colors.cross.grayson};
  }

  & dd {
    padding: 0;
    margin: 0;
    font-size: ${rem('14px')};
    font-weight: 600;
    color: #000;
  }
`;

export const StyledActionsButtonContainer = styled.dl`
  display: flex;
  grid-column: 1 / -1;
  grid-row: auto;
  justify-content: center;
  gap: ${rem('8px')};
`;

export const StyledFullWidthDLItem = styled.div`
  grid-column: 1 / -1;
  grid-row: auto;
`;

export const StyledActionsContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.cross.ultralightGray};
  border-radius: ${rem('8px')};
  padding: ${rem('16px')};
`;

export const StyledLinkToProperty = styled.a`
  color: ${({ theme }) => theme.colors.cross.black};
  text-decoration: underline;
  display: flex;
  gap: ${rem('8px')};
  align-items: center;
  appearance: none;
  text-underline-offset: 4px;
  font-size: ${rem('14px')};
  width: max-content;
`;

export const StyledButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledButton = styled(CtaButton)`
  cursor: pointer;

  &:not(:first-child) {
    margin-left: ${rem('12px')};
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.m}) {
    &:not(:first-child) {
      margin-left: ${rem('0px')};
    }
  }
`;

export const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${rem('10px')};
`;

export const StyledCtaButton = styled(CtaButton)<{
  user?: 'landlord' | 'tenant';
  variant?: 'primary' | 'secondary';
  wideOnMobile?: boolean;
}>`
  margin-top: ${rem('8px')};
  ${({ user, variant }) =>
    variant === 'primary'
      ? {
          background: theme.colors[user ?? 'tenant'].main,
          color: '#fff',
        }
      : {
          border: `1px solid ${theme.colors[user ?? 'tenant'].main}`,
          color: theme.colors[user ?? 'tenant'].main,
          backgroundColor: '#fff !important',
        }};
  display: flex;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.s}) {
    ${({ wideOnMobile }) =>
      wideOnMobile
        ? {
            width: '100%',
            justifyContent: 'center !important',
          }
        : {
            width: 'auto',
          }}
    justify-content: space-between;
  }
`;

export const StyledSpinner = styled(Spinner)`
  margin-right: ${rem('5px')};
`;

export const StyleButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.s}) {
    justify-content: space-between;
  }
`;
